// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"timer_timer-container__2aPJP","timer-content":"timer_timer-content__2iFHN","timer-content-ar":"timer_timer-content-ar__1g3d7"};